import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { GeographicalMapModule } from '../geographical-map/geographical-map.module';
import { ProjectDisplayModule } from '../project-display/project-display.module';
import { GeographicalSummaryDataService } from './data-access/geographical-summary-data.service';
import { GeographicalSummaryPageComponent } from './feature/geographical-summary-page/geographical-summary-page.component';
import { CountrySummaryCardComponent } from './ui/country-summary-card/country-summary-card.component';
import { GeographicalProjectsListComponent } from './ui/geographical-projects-list/geographical-projects-list.component';
import { GeographicalSummaryChartComponent } from './ui/geographical-summary-chart/geographical-summary-chart.component';

@NgModule({
  declarations: [
    GeographicalSummaryPageComponent,
    CountrySummaryCardComponent,
    GeographicalSummaryChartComponent,
    GeographicalProjectsListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatRadioModule,
    GeographicalMapModule,
    ProjectDisplayModule
  ],
  providers: [GeographicalSummaryDataService],
  exports: [GeographicalSummaryPageComponent]
})
export class GeographicalSummaryModule { }
